import { ForwardedRef, forwardRef } from 'react';

import {
  MapIcons,
  Container,
  StyledSection,
  ContentContainer,
  ArticleWrapper,
} from '@components/atoms';
import useDevice from '@hooks/useDevice';
import { Map } from '@components/organisms';
import { Article, SectionHeader } from '@components/molecules';

function Locations({}, ref: ForwardedRef<HTMLDivElement | null>) {
  const { isMobile, isTablet, isLaptop, isDesktop } = useDevice();

  return (
    <StyledSection ref={ref}>
      <Container>
        <ContentContainer>
          <SectionHeader title="Our Locations" src="icons/cactus.svg" />

          <ArticleWrapper>
            <Article
              align="center"
              titleMaxWidth="450px"
              descriptionMaxWidth="750px"
              wrapAlign="center"
              wrapWidth="100%"
              title="Power Lanes"
            />
          </ArticleWrapper>

          {(isLaptop || isDesktop) && <MapIcons />}
        </ContentContainer>
      </Container>

      <Map />

      {(isMobile || isTablet) && (
        <Container>
          <ContentContainer>
            <MapIcons />
          </ContentContainer>
        </Container>
      )}
    </StyledSection>
  );
}

export default forwardRef<HTMLDivElement | null, {}>(Locations);
